import { Component, DestroyRef, inject, input, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { INavContent } from '@garmin/components-global-web';
import { Scope } from '@garmin-avcloud/avcloud-fly-web-common/admin-authorization';
import { IconComponent } from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { LocalStorageKey, LocalStorageService } from '@garmin-avcloud/avcloud-web-utils';
import { environment } from '../../../environments/environment';
import { LdapOauthToken } from '../../core/models/ldap-oauth-token.model';
import { LdapTokenService } from '../../core/services/ldap-token/ldap-token.service';
import { NavigationTreeService } from '../../core/services/navigation-tree/navigation-tree.service';
import { NAVIGATION_TREE } from '../../modules/app-routing-structure';
import { NavigationComponent } from '../navigation/navigation.component';

@Component({
  selector: 'fly-header',
  imports: [IconComponent, NavigationComponent],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  private readonly navigationTreeService = inject(NavigationTreeService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly ldapTokenService = inject(LdapTokenService);
  readonly legacyUrl = environment.legacyFlyAdmin;
  readonly username = inject(LocalStorageService).get<LdapOauthToken>(LocalStorageKey.OAuthTokenResponse)?.username;
  readonly showWarningsLink = signal<boolean>(false);
  readonly mobileExpanded = signal<boolean>(false);
  readonly showAuthInfo = input(true);
  navigationTree = signal<INavContent[]>([]);

  ngOnInit(): void {
    this.ldapTokenService
      .hasScopes([Scope.WARNINGS_VIEW])
      .subscribe(([hasWarningScope]) => this.showWarningsLink.set(hasWarningScope));
    this.navigationTreeService
      .buildAuthorizedNavigationTree(NAVIGATION_TREE)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((authorizedNavigationTree) => {
        this.navigationTree.set(authorizedNavigationTree);
      });
  }

  signOut(): void {
    this.ldapTokenService.signOut();
  }

  toggleMobileExpanded(): void {
    this.mobileExpanded.update((expanded) => !expanded);
  }
}
